<div class="container {{ theme }}-theme" [class.disabled]="disabled" [class.no-label]="hideLabel">
	<div class="label" (click)="onLabelClick($event)" *ngIf="!hideLabel">
		<i *ngIf="labelIcon" class="fa-lg fa-{{ labelIcon }}"></i>
		{{ label }} 
		<span *ngIf="required && !hideRequiredMark" class="required-indicator">*</span>
		<bb-info *ngIf="infoMessage" [contents]="infoMessage" [link]="helpMessageLink" [icon]="'info'"></bb-info>
		<bb-info *ngIf="helpMessage" [contents]="helpMessage" [link]="helpMessageLink" [icon]="'help'"></bb-info>
	</div>

	<div class="input-wrapper">
		<div class="input" #inputWrapper [class.submitted]="form?.submitted">
			<ng-content></ng-content>
			<div class="button action-button" *ngIf="actionButtonIcon" [class.disabled]="actionButtonDisabled" (click)="actionButtonClicked($event)">
				<i class="fa" [ngClass]="'fa-' + actionButtonIcon"></i>
			</div>
			<div *ngIf="exceptions" class="invalid-message" [ngClass]="{'field-error': form?.submitted}">
				<div *ngFor="let error of formControl.errors | iterable">
					<div [ngSwitch]="error.key">
						<div *ngSwitchCase="'required'">{{ 'FIELD_IS_REQUIRED' | translate }}</div>
						<div *ngSwitchCase="'duplicate'">{{ 'DUPLICATE_CODE' | translate }}</div>
						<div *ngSwitchCase="'not-unique'">{{ 'VIOLATION_UNIQUE_CONSTRAINT_FIELD' | translate }}</div>
						<div *ngSwitchCase="'invalid-format'">{{ 'INVALID_FORMAT' | translate }}</div>
						<div *ngSwitchCase="'email'">{{ 'USER_INFO_EMAIL_INVALID' | translate }}</div>
						<div *ngSwitchCase="'min'">{{ 'FIELD_MIN_VALUE' | translate:error.value }}</div>
						<div *ngSwitchCase="'max'">{{ 'FIELD_MAX_VALUE' | translate:error.value }}</div>
						<div *ngSwitchDefault="">{{ error.value }}</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="postLabel" class="post-label" (click)="onLabelClick($event)">
			{{ postLabel }}
			<ng-container *ngIf="hideLabel">
				<bb-info *ngIf="infoMessage" [contents]="infoMessage" [link]="helpMessageLink" [icon]="'info'"></bb-info>
				<bb-info *ngIf="helpMessage" [contents]="helpMessage" [link]="helpMessageLink" [icon]="'help'"></bb-info>
			</ng-container>
		</div>
	</div>
</div>
